import React from 'react';

import s from './EmptyPostsList.module.scss';
import { useRouter } from 'next/navigation';

export const EmptyPostsList = () => {
  const router = useRouter();

  return (
    <div className={s.container}>
      <div className={s.root}>
        <div className={s.iconWrapper}>
          <WriteIcon />
        </div>
        <div className={s.title}>Looking to get help or share insights with the network?</div>
        <div className={s.desc}>No discussions here yet, but the first one can be yours!</div>
        <button className={s.trigger} onClick={() => router.push('/forum/posts/new')}>
          Create post
        </button>
      </div>
    </div>
  );
};

const WriteIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M28 15V26C28 26.5304 27.7893 27.0391 27.4142 27.4142C27.0391 27.7893 26.5304 28 26 28H6C5.46957 28 4.96086 27.7893 4.58579 27.4142C4.21071 27.0391 4 26.5304 4 26V5.99999C4 5.46956 4.21071 4.96085 4.58579 4.58578C4.96086 4.21071 5.46957 3.99999 6 3.99999H17C17.2652 3.99999 17.5196 4.10535 17.7071 4.29289C17.8946 4.48042 18 4.73478 18 4.99999C18 5.26521 17.8946 5.51956 17.7071 5.7071C17.5196 5.89464 17.2652 5.99999 17 5.99999H6V26H26V15C26 14.7348 26.1054 14.4804 26.2929 14.2929C26.4804 14.1054 26.7348 14 27 14C27.2652 14 27.5196 14.1054 27.7071 14.2929C27.8946 14.4804 28 14.7348 28 15ZM28.7075 8.70749L16.7075 20.7075C16.6146 20.8003 16.5042 20.8739 16.3829 20.9241C16.2615 20.9743 16.1314 21.0001 16 21H12C11.7348 21 11.4804 20.8946 11.2929 20.7071C11.1054 20.5196 11 20.2652 11 20V16C10.9999 15.8686 11.0257 15.7385 11.0759 15.6171C11.1261 15.4957 11.1997 15.3854 11.2925 15.2925L23.2925 3.29249C23.3854 3.19952 23.4957 3.12576 23.6171 3.07543C23.7385 3.02511 23.8686 2.99921 24 2.99921C24.1314 2.99921 24.2615 3.02511 24.3829 3.07543C24.5043 3.12576 24.6146 3.19952 24.7075 3.29249L28.7075 7.29249C28.8005 7.38537 28.8742 7.49566 28.9246 7.61705C28.9749 7.73845 29.0008 7.86858 29.0008 7.99999C29.0008 8.13141 28.9749 8.26154 28.9246 8.38293C28.8742 8.50433 28.8005 8.61462 28.7075 8.70749ZM26.5825 7.99999L24 5.41374L22.4137 6.99999L25 9.58624L26.5825 7.99999Z"
      fill="#1B4DFF"
    />
  </svg>
);
